import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutCallRecordTable extends Layout {
    sourceCallRecord: DataSource;
    tableCallRecords: Table;
}
